module.exports = __webpack_public_path__ + "static/img/3_5_1.3669817c.jpg";